import {
  criarTranscricaoAnexo,
  TranscricaoActionResult,
} from '../../../services/TranscricaoBeneficiarioService';
import { TranscricaoResourceToken } from '../../../interfaces/entities/Transcricao/transcricaoResourceToken';
import { TranscricaoAnexo } from './transcricaoTypes';

const MAX_NOME_ARQUIVO = 100;

export const limitarNomeArquivoTranscricao = (fileName: string): string => {
  if (fileName.length <= MAX_NOME_ARQUIVO) return fileName;
  return fileName.substring(fileName.length - MAX_NOME_ARQUIVO);
};

export const getContentTypeByTipoArquivoTranscricao = (tipoArquivo: string): string => {
  const tipo = tipoArquivo.toLowerCase();
  if (tipo === 'pdf') return 'application/pdf';
  if (tipo === 'jpg' || tipo === 'jpeg') return 'image/jpeg';
  if (tipo === 'png') return 'image/png';
  return 'application/octet-stream';
};

/** Anexo sem IA (ex.: Resolver Pendência). */
export const gravarTranscricaoAnexos = async (
  idTranscricao: TranscricaoResourceToken,
  anexos: TranscricaoAnexo[],
): Promise<TranscricaoActionResult> => {
  for (const anexo of anexos) {
    const resultado = await criarTranscricaoAnexo({
      idTranscricao,
      nomeArquivo: limitarNomeArquivoTranscricao(anexo.nomeArquivo),
      conteudo: anexo.arquivo,
      contentType: getContentTypeByTipoArquivoTranscricao(anexo.tipoArquivo),
    });

    if (!resultado.ok) {
      return resultado;
    }
  }

  return { ok: true };
};
